import {connect} from 'react-redux'
import {
    ActionsRow,
    commons,
    FixedDropDownButton,
    Icon,
    Loader,
    modal,
    utils
} from "@mc/mc-legacy";
import {Button, ButtonToolbar, CardBody, Col, DropdownItem, NavItem, NavLink, Row} from "reactstrap";
import AdminPage from "./AdminPage";
import * as subjektActions from "../../actions/subjektActions";
import * as polozkaActions from "../../actions/polozkaActions";
import {formatDate, getIdFromProps} from "../../utils/utils";
import {LinkContainer} from "react-router-bootstrap";
import TablePanel from "../../components/TablePanel";
import CenikForm from "../../forms/CenikForm";
import PolozkaApi from "../../api/gen/cgo/PolozkaApi";
import SubjektApi from "../../api/gen/cgo/SubjektApi";
const {sinkEvent} = commons;
import {ADMIN_BASE_PATH, SPOLECNOSTI_PATH} from "../../const/routes";
import {Component} from "react";
import * as React from "react";
import {withTranslation, WithTranslation} from "react-i18next";
import PripojCenikForm from "../../forms/PripojCenikForm";
import {CENIKY_SPOLECNOST_LIST_AREA} from "../../actions/polozkaActions";

/**
 * Stránka administrace - seznam ceníků konkrétní společnosti
 */
class SpolecnostCenikyPage extends Component<WithTranslation> {

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        this.props.dispatch(subjektActions.fetchSpolecnostDetailIfNeeded(getIdFromProps(this.props)));
        this.props.dispatch(polozkaActions.fetchCenikySpolecnostiIfNeeded(getIdFromProps(this.props)));
    };

    handleShowCenik = (cenik) => {
        const {spolecnostDetail} = this.props;
        this.props.history.push(`/${ADMIN_BASE_PATH}/${SPOLECNOSTI_PATH}/${spolecnostDetail.data.id}/ceniky/${cenik.id}`);
    };

    handleAttachCenik = () => {
        const {spolecnostDetail, t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            PripojCenikForm,
            {
                onSubmit: (data) => {
                    return SubjektApi.pripojCenikSpolecnost(spolecnostDetail.data.id, data.cenikId);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(polozkaActions.invalidateCenikySpolecnosti());
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
            },
            t('price_list_attach'),
            {size: "sm"}
        ));
    };

    handleDeleteCenik = (cenik) => {
        const {spolecnostDetail, t} = this.props;
        this.props.dispatch(
            modal.ModalActions.showConfirm(
                t('price_list_detach'),
                <span>{t('price_list_detach_info', {companyName: spolecnostDetail.data.nazevSpolecnost})}</span>,
                () => {
                    SubjektApi.odpojCenikSpolecnost(spolecnostDetail.data.id, cenik.id).then(() => {
                        this.props.dispatch(polozkaActions.invalidateCenikySpolecnosti());
                    });
                },
                null,
                t('detach')
            )
        );
    };

    renderContextMenu = (cenik) => {
        const {t} = this.props;
        return <FixedDropDownButton color="action action-hover" noCaret title={<Icon icon="ellipsis-v"/>}>
            <DropdownItem key="0" onClick={sinkEvent(this.handleShowCenik.bind(this, cenik))}>{t('show_detail')}</DropdownItem>
            <DropdownItem key="1" onClick={sinkEvent(this.handleDeleteCenik.bind(this, cenik))}>{t('detach')}</DropdownItem>
        </FixedDropDownButton>
    }

    render() {
        const {spolecnostDetail, cenikyList, t} = this.props;

        if (!spolecnostDetail.fetched || !cenikyList.fetched) {
            return <Loader/>;
        }

        let content;
        if (cenikyList.rows.length !== 0) {
            content = cenikyList.rows.map(cenik => {
                return <CardBody key={cenik.id}>
                    <ActionsRow actions={this.renderContextMenu(cenik)} onClick={this.handleShowCenik.bind(this, cenik)}>
                        <Row>
                            <Col xs={1}>{cenik.id}</Col>
                            <Col xs={3}>{cenik.nazevCenik}</Col>
                            <Col xs={3}>{cenik.aktivniOd ? formatDate(cenik.aktivniOd, "YYYY-MM-DD") : "-"}</Col>
                            <Col xs={3}>{cenik.aktivniDo ? formatDate(cenik.aktivniDo, "YYYY-MM-DD") : "-"}</Col>
                        </Row>
                    </ActionsRow>
                </CardBody>;
            });
        } else {
            content = <CardBody><i>{t('no_price_list')}</i></CardBody>
        }

        const spolecnost = spolecnostDetail.data;

        return <AdminPage
                title={t('admin.price_list_company',{companyName: spolecnost.nazevSpolecnost})}
                subtitle={t('admin.company_price_list_info', {companyName: spolecnost.nazevSpolecnost})}
                tabs={[
                    <NavItem key="1">
                        <LinkContainer replace to={`/${ADMIN_BASE_PATH}/${SPOLECNOSTI_PATH}/${getIdFromProps(this.props)}`}>
                            <NavLink active={false}><Icon icon="home" title={t('admin.company')}/></NavLink>
                        </LinkContainer>
                    </NavItem>,
                    <NavItem key="2">
                        <LinkContainer replace to={`/${ADMIN_BASE_PATH}/${SPOLECNOSTI_PATH}/${getIdFromProps(this.props)}/ceniky`}>
                            <NavLink active={true}>{t('admin.price_list_many')}</NavLink>
                        </LinkContainer>
                    </NavItem>
                ]}
                content={
                    <div>
                        <ButtonToolbar>
                            <Button color="primary" onClick={this.handleAttachCenik}>{t('attach')}</Button>
                        </ButtonToolbar>
                        <TablePanel header={
                            <Row>
                                <Col xs={1}>{t('labels.id')}</Col>
                                <Col xs={3}>{t('labels.name')}</Col>
                                <Col xs={3}>{t('active_from')}</Col>
                                <Col xs={3}>{t('active_to')}</Col>
                            </Row>
                        }>
                            {content}
                        </TablePanel>
                    </div>
                }
            />
    }
}

function mapStateToProps(state) {
    return {
        spolecnostDetail: utils.storeFromArea(state, subjektActions.SPOLECNOST_DETAIL_AREA),
        cenikyList: utils.storeFromArea(state, polozkaActions.CENIKY_SPOLECNOST_LIST_AREA),
    }
}

export default connect(mapStateToProps)(withTranslation()(SpolecnostCenikyPage));

